module.exports = __webpack_public_path__ + "img/formation_IARD.a38b7cee.png";